var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Header } from '../util/headers';
var storage = Symbol();
/** Returns true if the provided object was created from {@link buildStorage} function. */
export var isStorage = function (obj) { return !!obj && !!obj[storage]; };
/**
 * Builds a custom storage.
 *
 * **Note**: You can only create an custom storage with this function.
 *
 * @example
 *
 * ```js
 * const myStorage = buildStorage({
 *   find: () => {...},
 *   set: () => {...},
 *   remove: () => {...}
 * });
 *
 * const axios = setupCache(axios, { storage: myStorage });
 * ```
 */
export function buildStorage(_a) {
    var _b;
    var _this = this;
    var set = _a.set, find = _a.find, remove = _a.remove;
    return _b = {},
        //@ts-expect-error - we don't want to expose this
        _b[storage] = 1,
        _b.set = set,
        _b.remove = remove,
        _b.get = function (key) { return __awaiter(_this, void 0, void 0, function () {
            var value, stale;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, find(key)];
                    case 1:
                        value = _a.sent();
                        if (!value) {
                            return [2 /*return*/, { state: 'empty' }];
                        }
                        if (
                        // Not cached or fresh value
                        value.state !== 'cached' ||
                            value.createdAt + value.ttl > Date.now()) {
                            return [2 /*return*/, value];
                        }
                        if (!(value.data.headers &&
                            (Header.ETag in value.data.headers ||
                                Header.LastModified in value.data.headers ||
                                Header.XAxiosCacheEtag in value.data.headers ||
                                Header.XAxiosCacheLastModified in value.data.headers))) return [3 /*break*/, 3];
                        stale = {
                            data: value.data,
                            state: 'stale',
                            createdAt: value.createdAt
                        };
                        return [4 /*yield*/, set(key, stale)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, stale];
                    case 3: return [4 /*yield*/, remove(key)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, { state: 'empty' }];
                }
            });
        }); },
        _b;
}
